import React, { useState, useEffect } from 'react';

const PasswordProtect = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  // The password - change this to your desired password
  const SITE_PASSWORD = 'Heypass2026!';

  useEffect(() => {
    // Check if already authenticated
    const auth = localStorage.getItem('qasaba_authenticated');
    if (auth === 'true') {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === SITE_PASSWORD) {
      localStorage.setItem('qasaba_authenticated', 'true');
      setIsAuthenticated(true);
      setError('');
    } else {
      setError('Incorrect password. Please try again.');
      setPassword('');
    }
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-[#0B1121] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-white/20 border-t-white rounded-full animate-spin" />
      </div>
    );
  }

  if (isAuthenticated) {
    return children;
  }

  return (
    <div className="min-h-screen bg-[#0B1121] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img 
            src="/favicon.png" 
            alt="Qasaba Energy" 
            className="w-24 h-24 object-contain"
          />
        </div>

        {/* Card */}
        <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8">
          <h1 className="font-serif text-2xl text-white text-center mb-2">
            Qasaba Energy
          </h1>
          <p className="text-white/60 text-center text-sm mb-8">
            This site is password protected
          </p>

          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-white/40 focus:outline-none focus:border-[#4ECDC4] transition-colors"
                autoFocus
                data-testid="password-input"
              />
            </div>

            {error && (
              <p className="text-red-400 text-sm mb-4 text-center" data-testid="password-error">
                {error}
              </p>
            )}

            <button
              type="submit"
              className="w-full py-3 bg-[#4ECDC4] hover:bg-[#3dbdb5] text-[#0B1121] font-medium rounded-lg transition-colors"
              data-testid="password-submit"
            >
              Enter Site
            </button>
          </form>
        </div>

        <p className="text-white/30 text-xs text-center mt-6">
          © {new Date().getFullYear()} Qasaba Energy. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default PasswordProtect;
